/**
 * Client Onboarding tipleri — V2 Faz E.
 *
 * Rentificial Ai'daki supplier-onboarding modülü KT'ye taşındı; onboarding
 * artık `Clients` + `ClientDocuments` üzerinde yaşıyor ve buradan yönetiliyor.
 */

/** Clients.OnboardingStatusId — backend durum makinesiyle birebir. */
export enum OnboardingStatus {
  Started = 1,
  DocsPending = 2,
  Review = 3,
  GreenApproved = 4,
  YellowReview = 5,
  RedRejected = 6,
  Verified = 7,
}

export const ONBOARDING_STATUS_LABEL: Record<number, string> = {
  1: "Başladı",
  2: "Belge Bekleniyor",
  3: "İncelemede",
  4: "Yeşil — Onaylandı",
  5: "Sarı — İnceleme",
  6: "Kırmızı — Reddedildi",
  7: "Doğrulandı",
};

/** Rozet rengi: durum ilerledikçe nötrden yeşile, ret kırmızıya. */
export const ONBOARDING_STATUS_COLOR: Record<number, string> = {
  1: "secondary",
  2: "info",
  3: "primary",
  4: "success",
  5: "warning",
  6: "danger",
  7: "success",
};

export const RISK_LANE_COLOR: Record<string, string> = {
  green: "success",
  yellow: "warning",
  red: "danger",
};

export interface OnboardingQueueItem {
  Id: string;
  ClientName: string | null;
  Email: string | null;
  Phone: string | null;
  TaxNumber: string | null;
  OnboardingStatusId: number;
  OnboardingStatus: string;
  RiskScore: number | null;
  RiskLane: string | null;
  SubmittedAt: string | null;
  DecidedAt: string | null;
  IsActive: boolean;
  Suspended: boolean;
  SectorName: string | null;
  DocCount: number;
  ApprovedDocCount: number;
  /** Durum makinesinin bu satırdan izin verdiği hedef durumlar. */
  AllowedTransitions: number[];
}

export interface OnboardingQueueResponse {
  Total: number;
  Skip: number;
  Take: number;
  Items: OnboardingQueueItem[];
}

export interface OnboardingDocument {
  Id: string;
  TypeId: number | null;
  TypeName: string | null;
  Location: string | null;
  Approved: boolean;
  Rejected: boolean;
  RejectReason: string | null;
  ReviewedAt: string | null;
  UploadedAt: string | null;
}

export interface OnboardingRisk {
  Score: number;
  Lane: string;
  Reasons: string[];
}

export interface OnboardingClient {
  Id: string;
  ClientName: string | null;
  Email: string | null;
  Phone: string | null;
  TaxNumber: string | null;
  TaxOffice: string | null;
  AuthorizedPerson: string | null;
  OnboardingStatusId: number;
  OnboardingStatus: string;
  RiskScore: number | null;
  RiskLane: string | null;
  Iban: string | null;
  SubmittedAt: string | null;
  DecidedAt: string | null;
  RejectReason: string | null;
  PhoneValidated: boolean;
  EmailValidated: boolean;
  CorporateValidated: boolean;
  IsActive: boolean;
  Suspended: boolean;
  Closed: boolean;
  QualityFloorPass: boolean;
  TrustTier: string;
  SectorName: string | null;
  AllowedTransitions: number[];
}

export interface OnboardingDetail {
  Client: OnboardingClient;
  Documents: OnboardingDocument[];
  Risk: OnboardingRisk;
}
